/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

// dev-only render profiler. tree-shaken from prod builds (import.meta.env.DEV === false).
// shows a render-count overlay + flashes components as they re-render. Skip under
// automation (Playwright/Currents) so its overlay/instrumentation doesn't interfere
// with e2e test recording.
if (import.meta.env.DEV && !navigator.webdriver) {
  void import('react-scan').then(({ scan }) => scan({ enabled: true }));
}
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { MsalProvider } from '@azure/msal-react';
import { Await } from 'react-router-dom';
import App from './App';
import { pca } from './authClient';
import LoadingScreen from './LoadingScreen';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container as Element);

root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingScreen />}>
      <Await resolve={pca}>
        {(resolvedInstance) => (
          <MsalProvider instance={resolvedInstance}>
            <App />
          </MsalProvider>
        )}
      </Await>
    </Suspense>
  </React.StrictMode>,
);

reportWebVitals();
